/* eslint-disable react/no-deprecated */
import { captureMessage } from '@sentry/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import Root from './components/App'

const rootElem = document.getElementById('react-root')

if (rootElem) {
	// Don't start react app if cart is not active
	createRoot(rootElem).render(<Root />)
	console.info(
		'React Cart Loaded.',
		import.meta.env.NODE_ENV,
		import.meta.env.PACKAGE_NAME,
		import.meta.env.PACKAGE_VERSION
	)
} else {
	const message = 'React Cart Root not found.'
	captureMessage(message, 'fatal')
	console.error(message)
}
